// eslint-disable-next-line @typescript-eslint/no-unused-vars
import {plain} from '@mapsight/ui/config/feature/sources';

export default {
	userGeolocation: plain(),
	searchResult: plain(),
};
